/**
 * Veeroute.Delivery
 * Veeroute Delivery API
 *
 * The version of the OpenAPI document: 3.15.183137
 * Contact: support@veeroute.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Possible work types:   * `LOCATION_ARRIVAL` - arrival at the location (finishing of the parking, allowed time window start).   * `READY_TO_WORK` - the performer is ready to work (finishing of waiting for the time window for work, waiting for location opening and demand time window start).   * `START_WORK` - getting started at the location (finishing of waiting for location opening, demand time window start, work start).   * `FINISH_WORK` - finish of work at the location (finishing of work, waiting for the suitable departure time to the next location).   * `LOCATION_DEPARTURE` - departure from the location.   * `BREAK` - break. 
 */
export enum JobTypeDelivery {
    LOCATION_ARRIVAL = 'LOCATION_ARRIVAL',
    READY_TO_WORK = 'READY_TO_WORK',
    START_WORK = 'START_WORK',
    FINISH_WORK = 'FINISH_WORK',
    LOCATION_DEPARTURE = 'LOCATION_DEPARTURE',
    BREAK = 'BREAK'
};

